import { Badge } from './ui/badge';
import { Card, CardContent } from './ui/card';
import { Star, Quote } from 'lucide-react';

export function Testimonials() {
  const testimonials = [
    {
      name: "Kiran Desai",
      position: "CEO",
      company: "TechVision Solutions",
      image: "https://images.unsplash.com/photo-1463453091185-61582044d556?w=150&h=150&fit=crop&crop=face",
      rating: 5,
      content: "Optiwizer transformed our business operations with Zoho CRM and automation. Our sales increased by 45% within 6 months of implementation. Their expertise in Zoho One is exceptional.",
      service: "Zoho CRM & Automation"
    },
    {
      name: "Megha Rao",
      position: "Operations Manager",
      company: "Global Retail Hub",
      image: "https://images.unsplash.com/photo-1519340333755-c1aa5571fd46?w=150&h=150&fit=crop&crop=face",
      rating: 5,
      content: "The integration of Zoho Books, Zoho Inventory, and Shiprocket has streamlined our entire order management process. What used to take hours now takes minutes. Highly recommended!",
      service: "Zoho Integration & Shiprocket"
    },
    {
      name: "Arjun Malhotra",
      position: "Founder",
      company: "FinTech Innovations",
      image: "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=150&h=150&fit=crop&crop=face",
      rating: 5,
      content: "Optiwizer's implementation of Zoho Analytics gave us insights we never had before. The custom dashboards and automated reports have revolutionized our decision-making process.",
      service: "Zoho Analytics & Reporting"
    },
    {
      name: "Sonal Jain",
      position: "Director",
      company: "Healthcare Plus",
      image: "https://images.unsplash.com/photo-1519125323398-675f0ddb6308?w=150&h=150&fit=crop&crop=face",
      rating: 5,
      content: "The team's expertise in Zoho Desk and MyOperator integration has improved our customer service response time by 70%. Our patient satisfaction scores are at an all-time high.",
      service: "Zoho Desk & MyOperator"
    },
    {
      name: "Rohit Bansal",
      position: "Managing Partner",
      company: "Legal Associates",
      image: "https://images.unsplash.com/photo-1465101178521-c1a9136a3b99?w=150&h=150&fit=crop&crop=face",
      rating: 5,
      content: "Zoho Creator customization for our legal practice management has been a game-changer. The workflow automation and document management features have increased our efficiency by 60%.",
      service: "Zoho Creator & Workflow"
    },
    {
      name: "Pooja Nair",
      position: "E-commerce Head",
      company: "Fashion Forward",
      image: "https://images.unsplash.com/photo-1511367461989-f85a21fda167?w=150&h=150&fit=crop&crop=face",
      rating: 5,
      content: "The seamless integration of Zoho Commerce, Razorpay, and Shiprocket has scaled our online business beyond expectations. Sales have tripled in the past year!",
      service: "E-commerce Integration"
    }
  ];

  return (
    <section className="py-16 lg:py-20 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <Badge className="mb-4 bg-blue-100 text-blue-800">Client Success Stories</Badge>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            What Our Clients Say About Our Zoho Solutions
          </h2>
          <p className="text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto">
            Discover how businesses across industries have transformed their operations 
            with our expert Zoho implementation and automation services.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
              <CardContent className="p-4 lg:p-6">
                <div className="flex items-center mb-4">
                  <div className="flex space-x-1">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="h-4 w-4 text-yellow-400 fill-current" />
                    ))}
                  </div>
                  <Badge variant="secondary" className="ml-auto text-xs">
                    {testimonial.service}
                  </Badge>
                </div>
                
                <div className="relative mb-4">
                  <Quote className="absolute -top-2 -left-2 h-8 w-8 text-blue-200" />
                  <p className="text-gray-600 italic pl-6 text-sm lg:text-base leading-relaxed">
                    "{testimonial.content}"
                  </p>
                </div>
                
                <div className="flex items-center pt-4 border-t border-gray-100">
                  <div>
                    <h3 className="font-semibold text-gray-900 text-sm lg:text-base">
                      {testimonial.name}
                    </h3>
                    <p className="text-gray-600 text-xs lg:text-sm">
                      {testimonial.position}, {testimonial.company}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Stats Section */}
        <div className="mt-12 lg:mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 lg:gap-8">
          <div className="text-center">
            <div className="text-2xl lg:text-3xl font-bold text-blue-600 mb-2">500+</div>
            <div className="text-gray-600 text-sm lg:text-base">Happy Clients</div>
          </div>
          <div className="text-center">
            <div className="text-2xl lg:text-3xl font-bold text-blue-600 mb-2">98%</div>
            <div className="text-gray-600 text-sm lg:text-base">Success Rate</div>
          </div>
          <div className="text-center">
            <div className="text-2xl lg:text-3xl font-bold text-blue-600 mb-2">15+</div>
            <div className="text-gray-600 text-sm lg:text-base">Zoho Applications</div>
          </div>
          <div className="text-center">
            <div className="text-2xl lg:text-3xl font-bold text-blue-600 mb-2">5+</div>
            <div className="text-gray-600 text-sm lg:text-base">Years Experience</div>
          </div>
        </div>
      </div>
    </section>
  );
}